interface SectionHeadingProps {
  index: string;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  index,
  title,
  subtitle,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-7">
      <div className="flex items-start gap-3 md:gap-4">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-foreground-950 font-heading text-lg text-accent-400">
          {index}
        </span>
        <div>
          <h2 className="font-heading text-2xl leading-tight text-foreground-950 md:text-3xl">
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-1 text-xs text-foreground-600 md:text-sm">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {actionLabel && actionHref ? (
        <a
          href={actionHref}
          className="group flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:text-sm"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
        </a>
      ) : null}
    </div>
  );
}